import { NotificationManager } from 'react-notifications';
// 'info', 'success', 'warning', 'error'
const notification = ({
  type = 'error',
  message = '',
  title = 'Coinstable',
  timeOut = 4000,
  callback = () => {},
  priority = false,
}) => {
  return NotificationManager[type](message, title, timeOut, callback, priority);
};

export default notification;
